const Vuex = require('vuex');
const debug = process.env.NODE_ENV !== 'production';
import config from '@/config';

const state = {
  version: config.version.toString(),
};

const getters = {
  version(state) {
    if (state.version) {
      return `${state.version[0]}.${state.version[1]}.${parseInt(state.version.slice(-2))}`;
    }
  },
  device() {
    return {
      href: document.location.href,
      width: window.innerWidth,
      height: window.innerHeight,
      pixelRatio: window.devicePixelRatio,
      agent: navigator.userAgent,
      orientation: window.innerWidth < window.innerHeight,
    };
  },
};

const actions = {};

const mutations = {};


const moduleFiles = require.context('./modules', true, /\.js$/);
const modules = {};
moduleFiles.keys().forEach((f) => {
  const [, key] = f.match(/\.\/(.+)\.js$/);
  const file = moduleFiles(f);
  if (file && file.default) {
    modules[key] = file.default;
  }
});

/** 刷新后立刻 commit login，恢复 token、主题、threads，避免首屏无 Authorization 导致 401 清会话 */
function restoreSessionFromStorage(store) {
  try {
    const raw = localStorage.getItem('session');
    if (!raw) return;
    const session = JSON.parse(raw);
    if (session && session.id && session.token) {
      store.dispatch(`session/whoami`,session.token)
    }
  } catch (e) {
    /* ignore */
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules,
  strict: debug,
  plugins: [restoreSessionFromStorage],
});
